import { useState, useEffect } from "react";
import { updateCurrentUserDisplayName } from "../../../../../global/paywall/paywallUtils";
import { CustomerDetails, DetailUpdateError } from "../../../../../global/paywall/useDetailsUpdate";


interface PersonalDetailsProps {
    customerDetails: CustomerDetails;
    saveCustomerDetails: () => Promise<boolean>;
    error: DetailUpdateError;
    saved: boolean;
    setStateCustomerDetails: (value: CustomerDetails) => void;
}

export const validationSchema = {
    email: {
        required: false,
        message: "שדה חובה",
        validate: (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || "כתובת מייל לא תקינה",
    },
    firstName: {
        required: true,
        message: "שדה חובה",
        validate: (value: string) => {
            if (value.length > 50) return "שם פרטי יכול להכיל עד 50 תווים";
            return /^[^0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/.test(value) || "שם פרטי יכול להכיל רק אותיות";
        },
    },
    lastName: {
        required: true,
        message: "שדה חובה",
        validate: (value: string) => {
            if (value.length > 50) return "שם משפחה יכול להכיל עד 50 תווים";
            return /^[^0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/.test(value) || "שם משפחה יכול להכיל רק אותיות";
        },
    },
    phoneNumber: {
        required: true,
        message: "שדה חובה",
        validate: (value: string) => /^05\d{8}$/.test(value) || "מספר טלפון לא תקין",
    },
};

const fieldConfig = {
    email: { id: 1, name: "email", type: "text", label: "משתמש", disabled: true, order: 4 },
    firstName: { id: 2, name: "firstName", type: "text", label: "שם פרטי", order: 1 },
    lastName: { id: 3, name: "lastName", type: "text", label: "שם משפחה", order: 2 },
    phoneNumber: { id: 4, name: "phoneNumber", type: "tel", inputmode: "numeric", pattern: "[0-9]*", order: 3, label: "מספר טלפון" },
};

const CalcalistPaywallMyAccountPersonalDetails = (props: PersonalDetailsProps) => {

    const [fieldErrors, setFieldErrors] = useState<{ [key: string]: string }>({});
    const { customerDetails, setStateCustomerDetails, saveCustomerDetails, error, saved } = props;
    const [generalError, setGeneralError] = useState("");

    useEffect(() => {
        if (customerDetails && customerDetails.email) {
            const phoneValidation = validateField("phoneNumber", customerDetails.phoneNumber || "");
            setFieldErrors({
                ...fieldErrors,
                phoneNumber: phoneValidation.error
            });
        }
    }, [customerDetails.email]);

    const validateField = (name: string, value: string): { isValid: boolean; error: string } => {
        const field = validationSchema[name];
        if (!field) return { isValid: false, error: "שדה לא מוכר" };
        if (field.required && !value.trim()) {
            return { isValid: false, error: field.message };
        }
        if (!field.required && value.trim() === '') {
            return { isValid: true, error: "" };
        }
        const isValid = field.validate(value) === true;
        const error = isValid ? "" : field.validate(value) as string;
        return { isValid, error };
    };

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        const { isValid, error } = validateField(name, value);
        setStateCustomerDetails({ ...customerDetails, [name]: value });
        setFieldErrors({ ...fieldErrors, [name]: error });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await updateUserData();
        } catch (error) {
            console.error("Error sending form data:", error);
            setGeneralError("שגיאה בשמירת הנתונים. אנא נסו שוב מאוחר יותר.");
            return;
        }
    };


    const updateUserData = async () => {
        try {
            const response = await saveCustomerDetails();
            if (response) {
                updateCurrentUserDisplayName(customerDetails);
            }
        } catch (error) {
            console.error(error);
            setGeneralError("משהו השתבש, נסו שוב מאוחר יותר");
        }
    };

    const allFieldsValid = Object.keys(customerDetails).every(fieldName => !fieldErrors[fieldName]);





    return (
        <div className="CalcalistPaywallMyAccountPersonalDetails">
            <div className="personal-details-form">
                <form id="checkout-personal-details" onSubmit={handleSubmit}>
                    {Object.keys(fieldConfig).map((fieldName) => {
                        const config = fieldConfig[fieldName];
                        const value = customerDetails[fieldName] || "";
                        const error = fieldErrors[fieldName];

                        return <div
                            className={`input-field ${fieldName}`}
                            style={{ order: config.order }}
                            key={config.id}>
                            <label>{config.label}</label>
                            <input
                                placeholder={config.label}
                                disabled={config.disabled}
                                type={config.type}
                                name={config.name}
                                value={value}
                                onChange={handleChange}
                                className={error ? "error" : ""}
                            />
                            {<span className="input-field-error">{error}</span>}
                        </div>
                    })}
                </form>
                <div className="general-error">{generalError}</div>
                <button disabled={!allFieldsValid || saved} form="checkout-personal-details" className="submit-button" type="submit">שמירת שינויים</button>
                {saved && <div className="success-message">השינויים נשמרו בהצלחה!</div>}
            </div>

        </div>
    );
};

export default CalcalistPaywallMyAccountPersonalDetails;